import React from 'react';
interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
  description?: string;
  fullWidth?: boolean;
}
export function Textarea({
  label,
  error,
  className = '',
  id,
  description,
  fullWidth = true,
  ...props
}: TextareaProps) {
  const inputId = id || props.name || Math.random().toString(36).substr(2, 9);
  return <div className={`${fullWidth ? 'w-full' : ''} flex flex-col gap-1.5`} data-id="element-1849" data-mp="2jmo5wkom2put">
      {label && <label htmlFor={inputId} className="block text-sm font-medium text-slate-700" data-id="element-1850" data-mp="2nnhwjltfuire">
          {label} {props.required && <span className="text-red-500" data-id="element-1851" data-mp="2sl9lc6ysdord">*</span>}
        </label>}
      <textarea id={inputId} className={`
          block w-full rounded-xl border-2 border-slate-200 bg-slate-50/50 
          px-4 py-2.5 text-sm transition-all duration-200
          placeholder:text-slate-400
          focus:border-seform-orange focus:bg-white focus:ring-0 focus:outline-none
          disabled:bg-slate-100 disabled:text-slate-500 disabled:cursor-not-allowed
          ${error ? 'border-red-300 focus:border-red-500 bg-red-50/10' : 'hover:border-slate-300'}
          ${className}
        `} rows={4} {...props} data-id="element-1852" data-mp="2xm7ax4m4ll2w" />
      {description && !error && <p className="text-xs text-slate-500" data-id="element-1853" data-mp="15ixlgpao7739">{description}</p>}
      {error && <p className="text-xs text-red-600 font-medium animate-pulse" data-id="element-1854" data-mp="10l5v3zpobt16">
          {error}
        </p>}
    </div>;
}